import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import { RECOMMENDED_SLOT_COUNT } from '../../../recommended-list/buildRecommendedItems';
import type {
	CategoryEntryPointExtraProps,
	CategoryEntryPointParams,
	CategoryEntryPointRuntimeProps,
} from '../../types';
// oxlint-disable-next-line eslint-plugin-import(extensions) -- Relay-generated .graphql.ts artifact; the `.graphql` suffix is required to resolve it
import RecommendedAgentResultsQuery from './__generated__/RecommendedAgentResultsQuery.graphql';
// oxlint-disable-next-line eslint-plugin-import(extensions) -- Relay-generated .graphql.ts artifact; the `.graphql` suffix is required to resolve it
import type { RecommendedAgentResultsQuery as RecommendedAgentResultsQueryType } from './__generated__/RecommendedAgentResultsQuery.graphql';
import { OOTB_AGENTS_BY_PRODUCT } from './constants';
import { getRecentAgents } from './recentAgents';
import { resolveTemplateProduct } from './resolveTemplateProduct';

const TEMPLATE_PAGE_SIZE = 50;

type RecommendedAgentResultsEntryPointComponent = EntryPointComponent<
	{ recommendedAgentResultsQuery: RecommendedAgentResultsQueryType },
	Record<string, never>,
	CategoryEntryPointRuntimeProps,
	CategoryEntryPointExtraProps
>;

export const recommendedAgentResultsEntryPoint: EntryPoint<
	RecommendedAgentResultsEntryPointComponent,
	CategoryEntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<RecommendedAgentResultsEntryPointComponent>(() => import(/* webpackChunkName: "@atlaskit-internal_studio-browse-kit_recommended-agent-results" */ "./RecommendedAgentResults"), { moduleId: "479faee3", moduleName: "RecommendedAgentResults", modulePath: "../platform/packages/ai-mate/studio-agent-browse/src/ui/browse-agent/entrypoints/recommended/RecommendedAgentResults.tsx", priority: "interaction", moduleId: 'studio-browse-kit_recommended-agent-results',
		}),
	getPreloadProps: ({ cloudId, product, fetchPolicy = 'store-or-network' }) => {
		const recentAgentIds = getRecentAgents(cloudId);
		const externalReferences =
			OOTB_AGENTS_BY_PRODUCT[product as keyof typeof OOTB_AGENTS_BY_PRODUCT] ??
			OOTB_AGENTS_BY_PRODUCT.default;
		const [ootb1 = '', ootb2 = '', ootb3 = ''] = externalReferences;

		return {
			queries: {
				recommendedAgentResultsQuery: {
					parameters: RecommendedAgentResultsQuery,
					variables: {
						cloudIdString: cloudId,
						agentsPerSource: RECOMMENDED_SLOT_COUNT,
						first: TEMPLATE_PAGE_SIZE,
						hasRecentAgents: recentAgentIds.length > 0,
						ids: recentAgentIds,
						product,
						templateProduct: resolveTemplateProduct(product),
						ootb1,
						ootb2,
						ootb3,
						hasOotb1: Boolean(ootb1),
						hasOotb2: Boolean(ootb2),
						hasOotb3: Boolean(ootb3),
					},
					options: { fetchPolicy },
				},
			},
			entryPoints: {},
			extraProps: { product },
		};
	},
});
